export const CO_GET_QUALITYRATING_LISTING = "CO_GET_QUALITYRATING_LISTING"
export const CO_GET_QUALITYRATING_LISTING_SUCCESS = "CO_GET_QUALITYRATING_LISTING_SUCCESS"
export const CO_GET_QUALITYRATING_LISTING_FAILED = "CO_GET_QUALITYRATING_LISTING_FAILED"